import React from "react";

export const NotFound: React.FC = () => (
    <div className="container not-found">
        <span>404</span>
    </div>
);
